/* @flow */
import { groupBy, forEach } from 'lodash';
import { TARGET_TYPES } from 'entities/Message';
import type { Target } from 'entities/Message';

export function putMessageRecipientsForTargets(targets: Target[]): Array<*> {
  return targets.map((target: Target) => {
    const filterArray = [];
    if (target.selectedFilters && target.selectedFilters.length) {
      const groupedFilters = groupBy(target.selectedFilters, 'type');
      forEach(groupedFilters, (values, type) => {
        filterArray.push({
          [type]: values.map(value => value.value.id),
        });
      });
    } else if (target.role) {
      filterArray.push({ roles: [target.role] });
    }
    const recipient = {
      type: target.type.replace('_target', ''),
      uuid: target.uuid,
      filters: filterArray,
    };
    return recipient;
  });
}

export function allTargetsAreGroups(targets: Target[]): boolean {
  return !targets.some(t => t.type !== TARGET_TYPES.GROUP_TARGET);
}
